import React, { useEffect, useRef } from 'react';
import { FileUpload } from 'primereact/fileupload';
import { FILE_UPLOAD_MAX_SIZE } from '@/Config/constants';

/**
 * A customizable file upload template
 */
const FileUploadTemplate = ({
    multiple = true,
    auto = true,
    accept = "image/*",
    maxFileSize = FILE_UPLOAD_MAX_SIZE,
    uploadHandler,
    emptyTemplate = 'Drag and drop files here to upload.',
    onFileRemove,
    itemTemplate,
    disabled,
    triggerClear,
    customProps
}) => {
    const fileUploadRef = useRef();

    // const onFileRemove = (event) => {
    //     // TO DO: add a confirmation here
    //     console.log(event);
    // }

    useEffect(() => {
        if (triggerClear) {
            fileUploadRef.current.clear();
        }
    }, [triggerClear]);

    return (
        <div className="general-file-upload">
            <FileUpload name="files[]"
                ref={fileUploadRef}
                multiple={multiple}
                auto={auto}
                accept={accept}
                maxFileSize={maxFileSize}
                customUpload
                emptyTemplate={emptyTemplate}
                uploadHandler={uploadHandler}
                onRemove={onFileRemove}
                itemTemplate={itemTemplate}
                disabled={disabled}
                {...customProps}
            />
        </div>
    );
};

export default FileUploadTemplate;